import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCardPaper = styled(Paper)({
  flex: 1,
  padding: "0.55rem",
  borderRadius: "var(--radius-sm)",
});

export const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "var(--space-sm)",
  color: "var(--color-text-primary)",
  fontWeight: "var(--font-weight-bold)",
  fontSize: "var(--font-size-base)",
});

export const ImageContainer = styled("div")({
  display: "flex",
  alignItems: "center",

  "& img": {
    width: "26px",
    height: "26px",
  },
});

export const TextInfoContainer = styled("div")({
  fontSize: "var(--font-size-clamp)",

  [`@media (max-width: var(--breakpoint-xxs))`]: {
    fontSize: "var(--font-size-body)",
  },
});

export const TotalValue = styled("span")({
  display: "inline-block",
  fontVariantNumeric: "tabular-nums",
});
